import { render, staticRenderFns } from "./video-player.vue?vue&type=template&id=f91d879c&scoped=true&"
import script from "./video-player.vue?vue&type=script&lang=js&"
export * from "./video-player.vue?vue&type=script&lang=js&"
import style0 from "./video-player.vue?vue&type=style&index=0&id=f91d879c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91d879c",
  null
  
)

export default component.exports